// extracted by mini-css-extract-plugin
module.exports = {"LabeledInput":"LabeledInput_LabeledInput__EDBXe","invalid":"LabeledInput_invalid__zVSTp"};